export default __webpack_public_path__ + "static/media/google_button.c7f200c5.png";